<template>
  <div class="web-billing"
       v-loading="loading"
       element-loading-text="正在下单"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="big-left">
      <div class="bl-top">
        <div class="bt-item">
          <span class="bt-number">{{serviceNo}}</span>
          <span class="bt-text">服务号</span>
        </div>
        <div class="bt-item" style="cursor: pointer" :class="{activeSex:tabIndex==0}" @click="choicePage(0)">
          <span class="bt-price">¥ {{itemTotal}}</span>
          <span class="bt-name">项目</span>
        </div>
        <div class="bt-item" style="cursor: pointer" :class="{activeSex:tabIndex==1}" @click="choicePage(1)">
          <span class="bt-price">¥ {{skuTotal}}</span>
          <span class="bt-name">卖品</span>
        </div>
        <div class="bt-item" style="cursor: pointer" :class="{activeSex:tabIndex==2}" @click="choicePage(2)">
          <span class="bt-price">¥ {{specTotal}}</span>
          <span class="bt-name">成品</span>
        </div>
      </div>
      <div class="bl-bottom">
        <div class="bb-item" @click="toMemberList">
          <img src="../../assets/images/tx.jpg" class="bc-img">
          <span>选择会员</span>
        </div>
<!--        <div class="bb-item" v-if="member" @click="toShopItems">-->
<!--          <span>商城</span>-->
<!--        </div>-->
        <div class="bb-item" v-if="member" @click="toMemberItems">
          <span>套餐</span>
        </div>
        <div class="bb-item" v-if="member" @click="toMemberCards">
          <span v-if="memberCard.cardName">{{memberCard.cardName}}</span>
          <span style="margin-top: 6px;color: red;font-size: 13px"
                v-if="memberCard.cardName">¥ {{memberCard.balance}}</span>
          <span v-else>会员卡</span>
        </div>
        <div class="bb-item" @click="toMbInfo(member)" v-if="member">
          <img v-if="!member.headPortrait&&member.sex==0" src="../../assets/images/nan.png" class="bc-img">
          <img v-if="!member.headPortrait&&member.sex==1" src="../../assets/images/nan.png" class="bc-img">
          <img v-if="!member.headPortrait&&member.sex==2" src="../../assets/images/nv.png" class="bc-img">
          <img v-if="member.headPortrait" :src="member.headPortrait" class="bc-img">
          <span>{{member.memberName}}</span>
        </div>
        <div class="bb-item" v-if="!member">
          <span>散客</span>
        </div>
      </div>
    </div>
    <div class="big-right">
      <div class="br-top">
        <TabItem
          v-if="tabIndex == 0"
          ref="tabItem"
          :itemData="itemData"
          :itemTotal="itemTotal.toString()"
          :mc="memberCard"
          @setItems="setItems"
        />
        <TabSku
          class="br-top"
          v-if="tabIndex == 1"
          ref="tabSku"
          :skuData="skuData"
          :skuTotal="skuTotal"
          :mc="memberCard"
          @setSkus="setSkus"
        />
        <TabSpec
          class="br-top"
          v-if="tabIndex == 2"
          ref="specSku"
          :specData="specData"
          :specTotal="specTotal"
          :mc="memberCard"
          :memberId="memberId"
          @setSpecs="setSpecs"
        />
      </div>
      <div class="br-bottom">
        <div class="br-btn">
          <div style="width: 50%;">
            <span class="br-sex" :class="{activeSex:orderSex==1}" @click="setOrderSex(1)">男</span>
            <span class="br-sex" :class="{activeSex:orderSex==2}" @click="setOrderSex(2)">女</span>
          </div>
          <div style="width: 50%;float: right;display: flex;flex-direction: row;justify-content: space-between">
            <span class="total">总计：<span style=" color: red;">￥{{ total }}</span></span>
            <button class="payment" @click="saveBillingOrder()">结 算</button>
            <button class="br-save" v-if="yyId" @click="fanhui()">返回预约列表</button>
            <button class="br-save" v-if="!yyId" @click="saveOrder()">保存并返回</button>
          </div>
        </div>
      </div>
    </div>

    <TabMemberList
      v-if="mbVisible"
      :mbVisible="mbVisible"
      :mbType="mbType"
      @setMember="setMember"
      @setMemberCard="setMemberCard"
      @closeML="closeML"
      @toAddMember="toAddMember"
      @sanke="sanke"
    />

    <TabSaveMember
      v-if="smVisible"
      :smVisible="smVisible"
      @setMember="setMember"
      @closeSM="closeSM"
    />

    <TabMemberCards
      v-if="mcVisible"
      :mcVisible="mcVisible"
      :memberId="memberId"
      :memberCardId="mcId"
      :member="member"
      @setMc="setMc"
      @recharge="recharge"
      @closeMC="closeMC"
    />

    <TabMemberItems
      v-if="miVisible"
      :miVisible="miVisible"
      :memberId="memberId"
      @setMemberItem="setMemberItem"
      @closeMI="closeMI"
    />

    <TabShopItems
      v-if="shopVisible"
      :shopVisible="shopVisible"
      :memberId="memberId"
      @setShopItem="setShopItem"
      @closeShop="closeShop"
    />

    <TabPayment
      v-if="payVisible"
      :payVisible="payVisible"
      :total="total"
      :member="member"
      :orderId="orderId"
      :memberCard="memberCard"
      @closePay="closePay"
      :data="data"
      :type="type"
      :yyId="yyId"
      :ishh="ishh"
    />

    <Qkinfo
      v-if="mxVisible"
      :mxVisible="mxVisible"
      :mxList="mxList"
      :memberId="memberId"
      @successQk="successQk"
      @closeQk="closeQk"
    />
  </div>
</template>

<script>
  import {getToken} from "../../utils/auth";
  import TabMemberList from "../common/member/memberList";
  import TabSaveMember from "../common/member/saveMember";
  import TabMemberCards from "../common/member/memberCards";
  import TabMemberItems from "../common/member/memberItems";
  import TabShopItems from "../common/member/shopItems";
  import TabPayment from "../billing/payment/payment";
  import TabItem from "./menber/items";
  import TabSku from "./menber/skus";
  import TabSpec from "./menber/specs";
  import Qkinfo from "./../cashier/arrears/qkinfo";

  export default {
    name: "billing",
    components: {
      TabMemberList,
      TabSaveMember,
      TabMemberCards,
      TabMemberItems,
      TabPayment,
      TabItem,
      TabSku,
      TabSpec,
      TabShopItems,
      Qkinfo,
    },
    data() {
      return {
        mbType: 'item',
        type: '',
        orderId: '',
        orderSex: 1,
        tabIndex: 0,

        serviceNo: '',
        items: [],

        itemData: [],
        skuData: [],
        specData: [],

        mcId: '',
        memberId: '',
        member: {},
        memberCard: {},

        miNames: [],
        memberItem: {},

        itemTotal: '0',
        skuTotal: 0,
        specTotal: 0,
        total: 0,
        data: {},

        saveVisible: false,
        mbVisible: false,
        smVisible: false,
        mcVisible: false,
        miVisible: false,
        payVisible: false,
        shopVisible: false,
        loading: false,

        yyId: '',

        mxVisible: false,
        mxList: [],

        ishh: false,

        mdtc: {
          '0': 1, //套餐包
          '1': 2, //办卡
          '2': 3, //续卡
          '3': 4, //单项
          '4': 5, //月卡
          '5': 6, //季卡
          '6': 7, //年卡
        }
      };
    },

    async created() {
      this.memberId = this.$route.query.memberId
      this.mcId = this.$route.query.mcId
      this.yyId = this.$route.query.yyId
      this.getServiceNo()
      await this.getMember()
      await this.getMaInfos()
    },

    methods: {

      //获取会员信息
      async getMember() {
        let res = await this.$get("/sw/getSwMbmber", {memberId: this.memberId, mcId: this.mcId});
        this.member = res.member
        if (res.member) {
          this.orderSex = res.member.sex
          if (res.member.sex == 0) {
            this.orderSex = 1
          }
        }
        if (res.memberCard) {
          this.memberCard = res.memberCard
          if (this.$refs.tabItem) {
            this.$refs.tabItem.changeMc(this.memberCard)
          }
        }
      },

      //选择tab页面
      choicePage(index) {
        this.tabIndex = index
      },

      //设置项目列表
      setItems(items, total, mi) {
        this.itemData = items
        this.itemTotal = parseFloat(total).toString()
        var to = parseFloat(this.skuTotal) + parseFloat(this.itemTotal) + parseFloat(this.specTotal)
        this.total = to.toFixed(2)
        if (mi && mi.memberItemId) {
          this.miNames.forEach(item => {
            item.memberItems.forEach(it => {
              if (it.id == mi.memberItemId) {
                it.uses = it.uses - 1
              }
            })
          })
        }
      },

      //设置卖品列表
      setSkus(skus, total) {
        this.skuData = skus
        this.skuTotal = parseFloat(total)
        var to = parseFloat(this.skuTotal) + parseFloat(this.itemTotal) + parseFloat(this.specTotal)
        this.total = to.toFixed(2)
      },

      //设置成品列表
      setSpecs(specs, total) {
        this.specData = specs
        this.specTotal = parseFloat(total)
        var to = parseFloat(this.skuTotal) + parseFloat(this.itemTotal) + parseFloat(this.specTotal)
        this.total = to.toFixed(2)
      },

      toMemberCards() {
        if (this.memberCard) {
          this.mcVisible = true
        }
      },

      //选择会员信息
      setMember(item) {
        this.smVisible = false
        this.member = item;
        if (item) {
          this.activeSex = item.sex
        }
        this.memberId = item.id
        this.memberCard = {}
        this.mcId = ''
        this.setTabMc('huan')
        this.closeML();
      },

      setMemberCard(mb, mc) {
        this.smVisible = false
        if (mb.id) {
          this.member = mb;
          this.memberId = mb.id
          this.activeSex = mb.sex
        }
        if (mc.id) {
          this.memberCard = mc
          this.mcId = mc.id
        }
        this.setTabMc('huan')
        this.closeML();
      },

      sanke() {
        this.smVisible = false
        this.member = null
        this.activeSex = 1
        this.memberId = ''
        this.memberCard = {}
        this.memberCards = []
        this.setTabMc('huan')
        this.closeML();
      },

      setTabAmount(type) {
        if (this.itemData.length > 0) {
          if (type=='huan') {
            this.itemData = this.itemData.filter(item => item.noteId == null || item.noteId === '');
          }
          var price = 0
          this.itemData.forEach(item => {
            item.price=item.oglPrice
            if (item.discount == 1) {
              if (this.memberCard.id) {
                let it = {}
                if (item.itemVips.length > 0) {
                  it = item.itemVips.find(item => item.cardId === this.memberCard.cardId);
                }
                if (it && it.cardId) {
                  item.price = it.vipPrice;
                } else {
                  //计算会员价
                  if (this.memberCard.itemDiscount > 0) {
                    item.price = this.calculationPrice(item.oglPrice, this.memberCard.itemDiscount)
                  }
                }
              }
            }
            var to = parseFloat(price) + parseFloat(item.price);
            price = to.toFixed(2)
          })
          this.itemTotal = price
          if (type=='huan'&&this.$refs.tabItem) {
            this.$refs.tabItem.setItemList(this.itemData, parseFloat(this.itemTotal))
          }
        }
        if (this.skuData.length > 0) {
          var price = 0
          this.skuData.forEach(item => {
            //计算会员价
            if (this.memberCard.id && this.memberCard.skuDiscount > 0) {
              item.price = this.calculationPrice(item.oglPrice, this.memberCard.skuDiscount)
            }else {
              item.price=item.oglPrice
            }
            price = parseInt(price) + parseInt(item.price)
          })
          this.skuTotal = price
        }
        if (this.specData.length > 0) {
          var price = 0
          this.specData.forEach(item => {
            //计算会员价
            if (this.memberCard.id && this.memberCard.skuDiscount > 0) {
              item.price = this.calculationPrice(item.oglPrice, this.memberCard.skuDiscount)
            }else {
              item.price=item.oglPrice
            }
            price = parseInt(price) + parseInt(item.price)
          })
          this.specTotal = price
        }
        var to = parseFloat(this.skuTotal) + parseFloat(this.itemTotal) + parseFloat(this.specTotal)
        this.total = to.toFixed(2)
      },

      async saveOrder() {
        this.loading = true
        let mcId = ''
        if (this.memberCard && this.memberCard.id) {
          mcId = this.memberCard.id
        }
        var data = {
          itemStr: JSON.stringify(this.itemData),
          skuStr: JSON.stringify(this.skuData),
          specStr: JSON.stringify(this.specData),
          total: this.total,
          memberId: this.memberId,
          mcId: mcId,
          orderSex: this.orderSex,
          token: getToken(),
          serviceNo: this.serviceNo
        }
        let res = await this.$post("/sw/saveBillingOrder", data);
        if (res.code == 200) {
          this.loading = false
          this.$router.go(-1)
        } else {
          this.$message.error(res.message);
        }
      },

      async saveBillingOrder() {
        let mcId = ''
        if (this.memberCard && this.memberCard.id) {
          mcId = this.memberCard.id
        }
        var data = {
          itemStr: JSON.stringify(this.itemData),
          skuStr: JSON.stringify(this.skuData),
          specStr: JSON.stringify(this.specData),
          total: this.total,
          memberId: this.memberId,
          mcId: mcId,
          orderSex: this.orderSex,
          token: getToken(),
          serviceNo: this.serviceNo,
          payType: '',
          hh: null,
        }
        this.data = data
        this.ishh = this.checkOnlyOneNonEmpty()
        this.payVisible = true;

      },
      checkOnlyOneNonEmpty() {
        const isAValid = Array.isArray(this.itemData) && this.itemData.length > 0;
        const isBValid = Array.isArray(this.skuData) && this.skuData.length > 0;
        const isCValid = Array.isArray(this.specData) && this.specData.length > 0;
        return (isAValid + isBValid + isCValid) === 1;
      },

      closePay() {
        this.payVisible = false;
      },

      toAddMember() {
        this.smVisible = true;
      },

      closeSM() {
        this.smVisible = false;
      },

      setMc(item) {
        this.memberCard = item
        this.mcId = item.id
        this.setTabMc()
        this.mcVisible = false;
      },

      closeMC() {
        this.mcVisible = false;
      },

      setMemberItem(data) {
        let tcNum = data.tcNum
        let item = data.item
        let itemSign = 0
        itemSign = this.mdtc[item.miType]
        for (let i = 1; i <= tcNum; i++) {
          this.itemData.push({
            itemId: item.itemId,
            storeDeptId: item.storeDeptId,
            itemName: item.itemName,
            price: 0,
            oglPrice: item.oglPrice,
            itemSign: itemSign,
            discount: 0,
            noteId: item.id,
            first: item.first,
            second: item.second,
            third: item.third,
            mdAch: item.mdAch,
            kdAch: item.kdAch,
            deptId: item.deptId,
            femp: {},
            semp: {},
            temp: {},
          })
        }
        this.miVisible = false;
        this.tabIndex = 0
        if (this.$refs.tabItem) {
          this.$refs.tabItem.setListIndex()
        }
      },
      setShopItem(item) {
        let itemSign = 0
        if (item.lyType == 4) {
          //秒杀套餐
          itemSign = 5
        }
        if (item.lyType == 10) {
          //请客卡
          itemSign = 10
        }
        this.itemData.push({
          itemId: item.itemId,
          categoryId: item.categoryId,
          itemName: item.itemName,
          price: 0,
          actual: item.mdAch,
          oglPrice: item.price,
          itemSign: itemSign,
          discount: 0,
          noteId: item.id,
          first: item.firstAch,
          second: item.secondAch,
          third: item.thirdAch,
          firstCmn: item.firstCmn,
          secondCmn: item.secondCmn,
          thirdCmn: item.thirdCmn,
          femp: {},
          semp: {},
          temp: {},
        })
        this.shopVisible = false;
        this.tabIndex = 0
        if (this.$refs.tabItem) {
          this.$refs.tabItem.setListIndex()
        }
      },

      closeMI() {
        this.miVisible = false;
      },
      closeShop() {
        this.shopVisible = false;
      },


      toMembers() {
        this.mbVisible = true;
      },

      closeML() {
        this.mbVisible = false;
      },
      fanhui() {
        this.$router.back();
      },

      //服务号
      async getServiceNo() {
        let res = await this.$get("/sw/getServiceNo", {token: getToken()});
        this.serviceNo = res.serviceNo
      },

      //查询欠款
      async getMaInfos() {
        if (!this.memberId) {
          return;
        }
        let data = {
          memberId: this.memberId,
          token: getToken(),
        };
        let res = await this.$get("/sw/getMaInfos", data);
        if (res.list.length > 0) {
          this.mxList = res.list;
          this.mxVisible = true
        }
      },

      //还款成功
      successQk(item) {
        if (item.mcId) {
          this.getMember(item.mcId)
        }
        this.closeQk()
      },
      //关闭欠款的弹框
      closeQk() {
        this.mxVisible = false
      },

      //用户详情页
      toMbInfo(item) {
        if (item&&item.id) {
          this.$router.push(`/customers/memberInfo?memberId=` + item.id + '&kd=1');
        }
      },
      //选择性别
      setOrderSex(sex) {
        if (this.member) {
          return;
        }
        this.orderSex = sex
      },
      //计算价格
      calculationPrice(num1, num2) {
        var num = parseFloat(num1 * num2 / 10)
        return num.toFixed(2);
      },
      //充值
      recharge() {
        if (this.memberCard.id) {
          this.getMember(this.memberCard.id)
        }
        this.mcVisible = false
      },
      //门店套餐
      toMemberItems() {
        this.miVisible = true
      },

      //商城套餐
      toShopItems() {
        this.shopVisible = true
      },
      //用户列表
      toMemberList() {
        this.mbVisible = true
      },

      setTabMc(type){
        if (this.$refs.tabItem) {
          this.$refs.tabItem.changeMc(this.memberCard)
        }
        if (this.$refs.tabSku) {
          this.$refs.tabSku.changeMc(this.memberCard)
        }
        if (this.$refs.specSku) {
          this.$refs.specSku.changeMc(this.memberCard)
        }
        this.setTabAmount(type)
      }
    },
  };
</script>


<style lang="scss" scoped>
  .web-billing {
    width: 100%;
    height: 100vh;
    background-color: #F2F2F2;
    margin-right: 5px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
  }

  .big-left {
    width: 78px;
    border-right: #DDDDDD solid 1px;
    height: 100vh;
  }

  .bl-top {
    height: 50%;
  }

  .bt-item {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 20%;
    justify-content: center;
    align-items: center;
    border-bottom: #DDDDDD solid 1px;
  }

  .bt-number {
    color: #ff4d51;
    font-size: 28px;
    margin-bottom: 8px;
    font-weight: bold;
  }

  .bt-text {
    color: #A2A2A2;
    font-size: 16px;
  }

  .bt-name {
    font-size: 16px;
  }

  .bt-price {
    width: 60px;
    color: #FFFFFF;
    background-color: #DE4673;
    margin-top: -6px;
    margin-bottom: 10px;
    height: 20px;
    line-height: 20px;
    border-radius: 5px;
    font-size: 16px;
  }

  .bl-bottom {
    display: flex;
    flex-direction: column-reverse;
    height: 50%;
    width: 80px;
  }

  .bb-user {
    height: 15%;
  }

  .bb-card {
    height: 15%;
  }

  .bb-tc {
    height: 15%;
  }

  .bb-shop {
    height: 15%;
  }

  .bb-item {
    height: 70px;
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    justify-content: center;
    border-top: #DDDDDD solid 1px;
    font-size: 8px;
    cursor: pointer;
  }

  .bb-item span {
    font-size: 16px;
  }

  .bc-img {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin-bottom: 6px;
  }

  .big-right {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
  }

  .br-top {
    height: 94vh;
    overflow: hidden;
  }

  .br-bottom {
    width: 100%;
    height: 6vh;
    border-top: #DDDDDD solid 1px;
  }

  .br-btn {
    width: 100%;
    /*height: 100%;*/
    float: right;
    display: flex;
    align-items: center;
  }

  .br-btn .total {
    width: 60%;
    padding-right: 30px;
    height: 6vh;
    line-height: 6vh;
    text-align: right;
    font-size: 16px;
  }

  .payment {
    width: 25%;
    height: 6vh;
    border: 0;
    background-color: #e82742;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }

  .br-save {
    width: 25%;
    height: 6vh;
    border: 0;
    background-color: #595959;
    color: #fff;
    cursor: pointer;
    margin-left: 18px;
    font-size: 16px;
  }

  .br-sex {
    display: inline-block;
    background-color: #C2C6CD;
    margin-left: 12px;
    width: 32px;
    text-align: center;
    line-height: 32px;
    height: 32px;
    border-radius: 45px;
    font-size: 16px;
    cursor: pointer;
  }

  .activeSex {
    background-color: #666666;
    color: #ffffff;
  }

</style>
